var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"muven-top-progress",class:{ 'is-visible': _vm.state.visible },attrs:{"aria-hidden":"true"}},[_c('div',{staticClass:"muven-top-progress-bar",style:({ width: ((_vm.state.progress * 100) + "%") })})])}
var staticRenderFns = []

export { render, staticRenderFns }